/**
 * src/admin-ui/src/components/ProtectedRoute.tsx
 *
 * Authenticated route guard.
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { useAuthStore } from '../store/authStore';
import { FullScreenState } from './utility.styles';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuthStore();
  const location = useLocation();
  // Dev mode: bypass authentication completely when env variable flag is on
  if (process.env.REACT_APP_DISABLE_AUTH === 'true') {
    return <>{children}</>;
  }

  console.log('ProtectedRoute:', { 
    isAuthenticated, 
    loading, 
    pathname: location.pathname,
    from: location.state?.from?.pathname 
  });

  if (loading) {
    return (
      <FullScreenState>
        <CircularProgress size={60} />
      </FullScreenState>
    );
  }

  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to login');
    // Проверяем, не находимся ли мы уже на странице логина
    if (location.pathname === '/login') {
      console.log('Already on login page, not redirecting');
      return <>{children}</>;
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  console.log('Authenticated, rendering protected content');
  return <>{children}</>;
};

export default ProtectedRoute; 